//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { useState } from 'react';

export const useSelfDestructingMessage = (timeout: number): [boolean, () => void] => {
  const [showMessage, setShowMessage] = useState(false);

  const triggerMessage = () => {
    if (!showMessage) {
      setShowMessage(true);
      window.setTimeout(() => setShowMessage(false), timeout);
    }
  };

  return [showMessage, triggerMessage];
};

export default useSelfDestructingMessage;
